import { render } from "preact";

import { App } from "./app";
import "./styles/reset.css";
import "./styles/app.css";

const root = document.getElementById("app")!;

if (__FULL__) {
  // Full build: __SITE__ is one of pl|en|de|fr (guaranteed by vite.config.ts).
  // Dynamic import is intentional: under embed mode __FULL__ is `false` so
  // esbuild drops this block AND the chrome/ module entirely.
  const site = __SITE__ as "pl" | "en" | "de" | "fr";
  import("./chrome/Wrapper").then(({ Wrapper }) => {
    render(
      <Wrapper site={site}>
        <App />
      </Wrapper>,
      root,
    );
  });
} else {
  render(<App />, root);
}
